import { InjectionToken } from '@angular/core';
import { ModalWindowWithSwitcher } from './models';

export const MODAL_DEFINITION = new InjectionToken<ModalWindowWithSwitcher>('MODAL_DEFINITION');
